module.exports = "<p>\r\n  Unknown page!\r\n\r\n  <a routerLink=\"\" routerLinkActive=\"active\">Click here to go home.</a>\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/page-not-found.component.html
// module id = ./src/app/core/components/page-not-found.component.html
// module chunks = main